var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCelh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-db89dcfa-7595-4260-bc9e-b9b1cc581bfe",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-93e2b4e9-edd0-4d71-8ad9-42f347b5c986{fill:url(#uuid-99f7c8cf-073e-4c2c-89cf-be749834c207);}.uuid-e797ea43-7dfb-45f4-a77c-680fca5c1fd7{fill:url(#uuid-4beb6b53-41c7-4391-a5c6-e92b58a8a03b);fill-rule:evenodd;}.uuid-97afadbd-8e41-4e40-82b2-fe9c457ea5d5{fill:url(#uuid-9a481bec-d99d-47cc-91cc-80b8fc15bbaf);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4beb6b53-41c7-4391-a5c6-e92b58a8a03b",
    x1: 91.11,
    y1: 481.23,
    x2: 155.23,
    y2: 481.23,
    gradientTransform: "translate(0 641.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a2a3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-99f7c8cf-073e-4c2c-89cf-be749834c207",
    x1: 218.22,
    y1: 433.35,
    x2: 364.61,
    y2: 274.5,
    gradientTransform: "translate(0 641.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#585a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-9a481bec-d99d-47cc-91cc-80b8fc15bbaf",
    x1: 376.73,
    y1: 491.95,
    x2: 137.27,
    y2: 431.21,
    gradientTransform: "translate(0 641.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd478"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e797ea43-7dfb-45f4-a77c-680fca5c1fd7",
    d: "m123.17,191.88c17.71,0,32.06-14.35,32.06-32.06s-14.35-32.06-32.06-32.06h0c-17.71,0-32.06,14.35-32.06,32.06s14.35,32.06,32.06,32.06Zm0-18.32c7.59,0,13.74-6.15,13.74-13.74s-6.15-13.74-13.74-13.74-13.74,6.15-13.74,13.74,6.15,13.74,13.74,13.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-93e2b4e9-edd0-4d71-8ad9-42f347b5c986",
    d: "m326.54,322.14c10.53.73,32.8,11.27,48.92,34.17-25.82,29.43-63.08,46.29-102.23,46.26-75.31-.1-136.31-61.18-136.31-136.49.02-75.38,61.15-136.48,136.53-136.45,29.91,0,58.99,9.84,82.77,27.99,11.82,9.16-49.1,44.8-81.44,44.8-18.05,0-66.69,18.5-66.69,63.58,0,21.25,12.82,65.87,65.13,65.87,18.23,0,24.92-11.91,53.22-9.71h.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-97afadbd-8e41-4e40-82b2-fe9c457ea5d5",
    d: "m274.87,127.75h109.38c-18.96,58.08-64.86,71.64-85.56,71.64h-39.94c-65.96,1.56-108.65,41.59-121.84,61.56,4.58-106.45,97.84-133.2,137.96-133.2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCelh);
export default __webpack_public_path__ + "static/media/icon_celh.09d79101de8ca66a0942c78e437bb9bf.svg";
export { ForwardRef as ReactComponent };